import z from "zod";
import { COLORS } from "../../colors";

export const tableTypeSchema = z.object({
	color: z.enum(COLORS),
	icon: z.string(),
	id: z.string(),
	name: z.string().min(1),
	ranking: z.number(),
	state: z.enum(["active", "inactive"]),
	workspaceId: z.string().nullable(),
});

export const tableTypesFormSchema = z.object({
	types: z.array(tableTypeSchema),
});

export const tableTypesParamSchema = z.object({
	tableTypesTable: z.string(),
});

export const tableTypesQuerySchema = z.object({
	state: z
		.any()
		.transform((v) => (Array.isArray(v) ? v : [v]))
		.pipe(z.array(z.enum(["active", "inactive"]))),
});

export type TableTypeSchema = z.infer<typeof tableTypeSchema>;
export type TableTypesFormSchema = z.infer<typeof tableTypesFormSchema>;
